import {Package, TrendingUp, Clock, Star, List, User, MessageCircle} from "lucide-react";
import { motion } from "framer-motion";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from "recharts";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CourierPerformance({
  navigateTo
}) {
  const {
    t
  } = useCourierLanguage();
  const weeklyData = [{
    day: "B.e",
    deliveries: 12,
    earnings: 156
  }, {
    day: "Ç.a",
    deliveries: 15,
    earnings: 195
  }, {
    day: "Ç",
    deliveries: 10,
    earnings: 130
  }, {
    day: "C.a",
    deliveries: 18,
    earnings: 234
  }, {
    day: "C",
    deliveries: 14,
    earnings: 182
  }, {
    day: "Ş",
    deliveries: 8,
    earnings: 104
  }, {
    day: "B",
    deliveries: 6,
    earnings: 78
  }];
  const stats = [{
    label: t.totalDeliveries,
    value: "83",
    change: "+12%",
    icon: Package,
    color: "#2D58AD"
  }, {
    label: t.avgDeliveryTime,
    value: "24 dəq",
    change: "-5%",
    icon: Clock,
    color: "#F59E0B"
  }, {
    label: t.customerRating,
    value: "4.8",
    change: "+0.3",
    icon: Star,
    color: "#10B981"
  }, {
    label: t.totalEarnings,
    value: "₼1,079",
    change: "+18%",
    icon: TrendingUp,
    color: "#8B5CF6"
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4 pb-6",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "text-2xl font-bold",
        children: t.performance
      }), /*#__PURE__*/_jsx("p", {
        className: "text-white-80 text-sm",
        children: t.weeklyOverview
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-4 neg-mt-2",
      children: [/*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-2 gap-3 mb-6",
        children: stats.map((stat, index) => /*#__PURE__*/_jsxs(motion.div, {
          initial: {
            opacity: 0,
            y: 20
          },
          animate: {
            opacity: 1,
            y: 0
          },
          transition: {
            delay: index * 0.1
          },
          className: "bg-white rounded-2xl p-4 shadow-md",
          children: [/*#__PURE__*/_jsx("div", {
            className: "w-10 h-10 rounded-xl flex items-center justify-center mb-3",
            style: {
              backgroundColor: `${stat.color}20`
            },
            children: /*#__PURE__*/_jsx(stat.icon, {
              className: "w-5 h-5",
              style: {
                color: stat.color
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-2xl font-bold text---000080- mb-1",
            children: stat.value
          }), /*#__PURE__*/_jsx("p", {
            className: "text-xs text-neg-708094- mb-2",
            children: stat.label
          }), /*#__PURE__*/_jsxs("span", {
            className: `text-xs font-semibold ${stat.change.startsWith("+") || stat.change.startsWith("-") && !stat.change.includes("dəq") ? stat.change.startsWith("+") ? "text---10B981-" : "text-red-500" : "text-neg-708094-"}`,
            children: [stat.change, " ", t.thisWeek]
          })]
        }, stat.label))
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.4
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-6",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.weeklyDeliveries
        }), /*#__PURE__*/_jsx(ResponsiveContainer, {
          width: "100%",
          height: 200,
          children: /*#__PURE__*/_jsxs(BarChart, {
            data: weeklyData,
            children: [/*#__PURE__*/_jsx(CartesianGrid, {
              strokeDasharray: "3 3",
              stroke: "#E5E7EB"
            }), /*#__PURE__*/_jsx(XAxis, {
              dataKey: "day",
              tick: {
                fill: "#708094",
                fontSize: 12
              }
            }), /*#__PURE__*/_jsx(YAxis, {
              tick: {
                fill: "#708094",
                fontSize: 12
              }
            }), /*#__PURE__*/_jsx(Tooltip, {
              contentStyle: {
                backgroundColor: "white",
                border: "none",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }
            }), /*#__PURE__*/_jsx(Bar, {
              dataKey: "deliveries",
              fill: "#2D58AD",
              radius: [8, 8, 0, 0]
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.5
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-6",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.weeklyEarnings
        }), /*#__PURE__*/_jsx(ResponsiveContainer, {
          width: "100%",
          height: 200,
          children: /*#__PURE__*/_jsxs(LineChart, {
            data: weeklyData,
            children: [/*#__PURE__*/_jsx(CartesianGrid, {
              strokeDasharray: "3 3",
              stroke: "#E5E7EB"
            }), /*#__PURE__*/_jsx(XAxis, {
              dataKey: "day",
              tick: {
                fill: "#708094",
                fontSize: 12
              }
            }), /*#__PURE__*/_jsx(YAxis, {
              tick: {
                fill: "#708094",
                fontSize: 12
              }
            }), /*#__PURE__*/_jsx(Tooltip, {
              contentStyle: {
                backgroundColor: "white",
                border: "none",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
              }
            }), /*#__PURE__*/_jsx(Line, {
              type: "monotone",
              dataKey: "earnings",
              stroke: "#10B981",
              strokeWidth: 3,
              dot: {
                fill: "#10B981",
                r: 5
              }
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.home
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.packages
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("messages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(MessageCircle, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Messages"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-2D58AD-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.performance
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.profile
          })]
        })]
      })
    })]
  });
}